import React, { createContext, useContext, useState, useCallback } from "react";
import * as fin from "@/lib/finance";

const FinanceContext = createContext(null);

export function FinanceProvider({ children }) {
  const [finance, setFinance] = useState(() => fin.loadFinance());

  const refresh = useCallback(() => setFinance(fin.loadFinance()), []);
  const init = useCallback(() => setFinance(fin.ensureInitialized()), []);

  const wrap = (fn) => (...args) => {
    const d = fn(...args);
    setFinance(d);
    return d;
  };

  const value = {
    finance,
    household: finance?.household || null,
    hasHousehold: !!finance,
    setupCompleted: (finance?.incomeSources || []).length > 0,
    budgets: finance?.budgets || [],
    refresh,
    init,
    setHouseholdName: wrap(fin.setHouseholdName),
    addTransaction: wrap(fin.addTransaction),
    updateTransaction: wrap(fin.updateTransaction),
    deleteTransaction: wrap(fin.deleteTransaction),
    upsertIncome: wrap(fin.upsertIncome),
    deleteIncome: wrap(fin.deleteIncome),
    upsertRecurring: wrap(fin.upsertRecurring),
    deleteRecurring: wrap(fin.deleteRecurring),
    upsertDebt: wrap(fin.upsertDebt),
    deleteDebt: wrap(fin.deleteDebt),
    setEmergencyFund: wrap(fin.setEmergencyFund),
    upsertBudget: wrap(fin.upsertBudget),
    deleteBudget: wrap(fin.deleteBudget),
    dismissWeeklyRecap: wrap(fin.dismissWeeklyRecap),
    acknowledgeReminder: wrap(fin.acknowledgeReminder),
    upsertScenario: wrap(fin.upsertScenario),
    deleteScenario: wrap(fin.deleteScenario),
  };
  return <FinanceContext.Provider value={value}>{children}</FinanceContext.Provider>;
}

export function useFinance() {
  const c = useContext(FinanceContext);
  if (!c) throw new Error("useFinance must be used within FinanceProvider");
  return c;
}
